import { render, staticRenderFns } from "./keyboards.vue?vue&type=template&id=2ca0a633&scoped=true&"
import script from "./keyboards.vue?vue&type=script&lang=js&"
export * from "./keyboards.vue?vue&type=script&lang=js&"
import style0 from "./keyboards.vue?vue&type=style&index=0&id=2ca0a633&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0a633",
  null
  
)

export default component.exports